// Answers in the Academy community also land in this bell (GSL-6): the
// academy service posts them to alert_engine as system notifications with
// details.source = 'academy_community'. The drawer shows them as community
// notices and opens the question in the Academy.

export const COMMUNITY_NOTICE_SOURCE = 'academy_community';

// Question ids are UUIDs; anything else is not a link we build.
const QUESTION_ID = /^[A-Za-z0-9-]{1,64}$/;

/** The question a notification points to, or null when it is not a
 *  community notice. */
export function communityQuestionOf(n: { details?: Record<string, unknown> | null }): string | null {
  const d = n.details || {};
  if (d.source !== COMMUNITY_NOTICE_SOURCE) return null;
  const id = d.question_id;
  return typeof id === 'string' && QUESTION_ID.test(id) ? id : null;
}
